import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ProductionOrderViewModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:*',
  name: 'Production',
  label: 'Production-Orders',
  path: 'production',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ProductionOrders/View'))
  ),
  actions: {
    orderDetails: {
      id: 'PRODUCTION_ORDERS:VIEW:DETAILS',
      name: 'production-order-details',
      label: 'Order Details'
    },
    addOrderToPipeline: {
      id: 'PRODUCTION_ORDERS:VIEW:ADD-ORDER-TO-PIPELINE',
      name: 'add-order-to-pipeline',
      label: 'Add Order to Pipeline'
    },
    downloadSheet: {
      id: 'PRODUCTION_ORDERS:VIEW:DOWNLOAD-SHEET',
      name: 'download-sheet',
      label: 'Download Sheet'
    },
    cancelOrder: {
      id: 'PRODUCTION_ORDERS:VIEW:CANCEL-ORDER',
      name: 'cancel-order',
      label: 'Cancel Order'
    },
    startMaterialAllocation: {
      id: 'PRODUCTION_ORDERS:VIEW:MATERIAL-ALLOCATION',
      name: 'start-material-allocation',
      label: 'Material Allocation'
    },
    // viewPdiLogs: {
    //   id: 'PRODUCTION_ORDERS:VIEW:PDI-LOGS',
    //   name: 'view-pdi-logs',
    //   label: 'View Pdi Logs'
    // },
    // startPDI: {
    //   id: 'PRODUCTION_ORDERS:VIEW:START-PDI',
    //   name: 'start-pdi',
    //   label: 'Start PDI'
    // },
    // debug: {
    //   id: 'PRODUCTION_ORDERS:VIEW:DEBUG-INSPECTION',
    //   label: 'Debug Inspection',
    //   name: 'debug-inspection'
    // },
    // startPDIAgainstOrder: {
    //   id: 'ORDERS:VIEW:START-PDI-ORDER',
    //   name: 'start-pdi-against-order',
    //   label: 'Start PDI'
    // }
    viewProcessCount: {
      id: 'PRODUCTION_ORDERS:VIEW:PROCESS-COUNT-ACTION',
      name: 'view-process-count',
      label: 'View Process Count'
    },
    forceComplete: {
      id: 'PRODUCTION_ORDERS:VIEW:FORCE-COMPLETE',
      name: 'force-complete',
      label: 'Force Complete'
    }
  }
});

export const ProductionOrderDetailsModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:DETAILS',
  name: 'productionOrderDetails',
  path: 'production/details',
  pathDef: 'production/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ProductionOrders/Form'))
  )
});

export const AddProductionOrderModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:ADD_ORDER',
  name: 'addProductionOrder',
  path: 'production/add',
  // pathDef: 'order/details/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ProductionOrders/ADD'))
  ),
  actions: {
    addProductionOrder: {
      id: 'PRODUCTION_ORDERS:ACTION:ADD_ORDER',
      name: 'addProductionOrder',
      label: 'Add Order',
      run: () => {}
    }
  }
});

export const ProductionOrderPDIStartModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:PDI-START',
  name: 'productionOrderPDIStart',
  path: 'production/start-pdi',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Order/PDI'))
  )
});

export const ProductionOrderMaterialAllocationModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:MATERIAL-ALLOCATION',
  name: 'productionOrderMaterialAllocation',
  path: 'production/material-allocation',
  pathDef: 'production/material-allocation/:orderId',
  Component: ComponentLoader(
    lazy(() =>
      import('src/content/management/ProductionOrders/MaterialAllocation')
    )
  )
});

export const ProductionOrderProcessCountModule = new Module({
  id: 'PRODUCTION_ORDERS:VIEW:PROCESS-COUNT',
  name: 'productionOrderProcessCount',
  path: 'production/process-count',
  pathDef: 'production/process-count/:orderId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ProductionOrders/ProcessCount'))
  )
});

const ProductionOrderModules = [
  ProductionOrderViewModule,
  ProductionOrderDetailsModule,
  AddProductionOrderModule,
  ProductionOrderPDIStartModule,
  ProductionOrderMaterialAllocationModule,
  ProductionOrderProcessCountModule
];

export default new ModuleBundle('Production-Orders', ProductionOrderModules);
